module.exports = "/_next/static/images/icon-login-weibo-c1e1e513.png";